import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import {connect} from "react-redux";
import { patchCommerceLink } from 'redux/commerce/actions';

import onClickOutside from "react-onclickoutside";

import InputField from 'components/elements/InputField';

import './CommerceLinkTitle.css';

const ENTER_KEY = 13;


class CommerceLinkTitle extends Component {
  static propTypes = {
    patchCommerceLink: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    location: PropTypes.object,
    linkId: PropTypes.number.isRequired,
    patchCommerceLinkError: PropTypes.object,
  };

  static defaultProps = {
    location: null,
    patchCommerceLinkError: null,
  };

  state = {
    initialValue: null,
    currentValue: null,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    if (this.props.title) {
      this.setState({
        initialValue: this.props.title,
        currentValue: this.props.title,
      });
    }

    if (this.props.location) {
      const isInputFocused = this.useQuery(this.props.location.search);
      if (isInputFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.title !== this.props.title) {
      this.setState({ currentValue: this.props.title });
    }

    if (prevProps.location !== this.props.location) {
      const isInputFocused = this.useQuery(this.props.location.search);
      if (isInputFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  inputEditFieldRef = createRef();

  changeValue = () => {
    const { initialValue, currentValue } = this.state;

    if (
      currentValue !== initialValue &&
      currentValue.length > 0
    ) {
      this.setState({ initialValue: currentValue});
      const form = new FormData();
      form.append('title', currentValue);
      this.props.patchCommerceLink(this.props.linkId, form);
    }
  };

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      this.changeValue();
    }
  };

  useQuery = param => {
    return new URLSearchParams(param).get('focus');
  };

  handleClickOutside = () => {
    this.changeValue();
  };

  executeValidation = () => {
    const { patchCommerceLinkError } = this.props;
    const { currentValue } = this.state;

    if (patchCommerceLinkError && patchCommerceLinkError.title) {
      return patchCommerceLinkError.title;
    }
    if (currentValue === '' ) {
      return 'Title should not be empty';
    }
    return null;
  };

  render() {
    const { currentValue } = this.state;

    return (
      <div className="commerce-link-title__component">
        <div className="input-wrapper">
          <InputField
            value={currentValue}
            onChange={(e) => {
              e.preventDefault();
              this.setState({ currentValue: e.target.value });
            }}
            customRef={this.inputEditFieldRef}
            error={this.executeValidation() && {text: this.executeValidation()}}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    patchCommerceLinkError: state.commerceReducer.patchCommerceLinkError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchCommerceLink,
  },
)(onClickOutside(CommerceLinkTitle));
